import { render, staticRenderFns } from "./HubPage.vue?vue&type=template&id=5ccef2ba&"
import script from "./HubPage.vue?vue&type=script&lang=js&"
export * from "./HubPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports